import styled from 'styled-components';
import { ListItemContent } from '@frameio/vapor';

export const StyledListItemContent = styled(ListItemContent)`
  cursor: pointer;
`;
